import React, { useContext } from 'react';
import { UnionPayStackRoutes, UnionPayStackScreenProps } from '@/features/bill-payment/screens/union-pay/type';
import { LayoutContext } from 'contexts/LayoutContext';
import { UnionPayMoreMobileComponent } from '@/features/bill-payment/screens/union-pay/UnionPayMoreMobile.component';
import { UnionPayMoreWebComponent } from '@/features/bill-payment/screens/union-pay/UnionPayMoreWeb.component';

export interface UnionPayMoreScreenProps {}

export const UnionPayMoreScreen: React.FC<UnionPayStackScreenProps<UnionPayStackRoutes.UnionPayMore>> = ({ navigation, route }) => {
  const layout = useContext(LayoutContext);
  const {} = route.params;

  if (layout.isMobile) {
    return <UnionPayMoreMobileComponent />;
  }
  return <UnionPayMoreWebComponent />;
};
